import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import masterService from "services/MasterService";

export const initialState = {
  loading: false,
  message: "",
  list: null,
  sublist: null,
  subloading: false,
};

export const productCodeListAll = createAsyncThunk(
  "/product-code/list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await masterService.getProductCode(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const productCodeSlice = createSlice({
  name: "productCode",
  initialState,
  reducers: {
    productcodeList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(productCodeListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(productCodeListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      });
  },
});

export const { productCodeList } = productCodeSlice.actions;

export default productCodeSlice.reducer;
